<template>
  <my-options
    :list="options"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import MyOptions from '@/components/common/my-dropdown/index'
export default {
  components: {
    MyOptions
  },
  props: {
    // eslint-disable-next-line
    _options: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    options() {
      return this._options.options || []
    }
  }
}
</script>
